<template>
  <v-app class="split-bg">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <div class="layout column align-center">
                <v-img
                  :src="settings.branding.logo"
                  alt="Vue Material Admin"
                  max-width="266"
                  max-height="200"
                />
              </div>

              <div v-if="!sent">
                <v-card-text>
                  Please enter your email address. We'll send you an email with
                  instructions on how to reset your password.
                </v-card-text>
                <v-card-text>
                  <v-form>
                    <v-text-field
                      v-model="email"
                      outlined
                      dense
                      append-icon="email"
                      label="Email"
                      type="text"
                    />
                  </v-form>
                </v-card-text>
                <v-spacer />
                <v-btn
                  :disabled="!validEmail"
                  block
                  color="primary"
                  @click="sendResetPassword"
                >
                  Submit
                </v-btn>
              </div>
              <div v-else>
                <v-card-text>
                  Thank you for sending us your email. If your email is valid,
                  you will receive instructions on how to reset your password.
                </v-card-text>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { User, Associate } from "@/classes";
import isValidEmail from "@/modules/isValidEmail";
import request from "@/modules/request";
import settingsMixin from "../../mixins/settingsMixin";

export default {
  name: "ForgotPassword",
  props: {
    associate: {
      type: Boolean,
    },
  },
  mixins: [settingsMixin],
  data() {
    return {
      email: null,
      sent: false,
    };
  },
  computed: {
    validEmail() {
      return this.email && isValidEmail(this.email);
    },
  },
  methods: {
    async sendResetPassword() {
      const { associate, email } = this;
      await request.callInternal({
        method: "post",
        route: "/api/initiatepasswordreset",
        data: {
          associate,
          email,
        },
      });
      this.sent = true;
    },
  },
};
</script>

<style scoped>
.split-bg {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
